// Auto-generated by scripts/generate_daily_seo_content.js
// Do not edit this file manually.

const dailySeoContent = {
  "updatedAt": "2026-10-14",
  "topic": "德州扑克新手教程 / 德州扑克规则 / 德州扑克新手规则",
  "metaKeywords": "德州扑克新手教程, 德州扑克规则, 德州扑克新手规则, 德州扑克入门教程, 德州扑克平台怎么选, 德州扑克平台下载, 德扑平台安装教程, 德州扑克平台客服, hhpoker官网, hhpoker最新下载",
  "focusKeywords": [
    {
      "keyword": "德州扑克新手教程",
      "path": "/guide",
      "anchorText": "德州扑克新手教程详解"
    },
    {
      "keyword": "德州扑克规则",
      "path": "/guide",
      "anchorText": "德州扑克规则攻略"
    },
    {
      "keyword": "德州扑克新手规则",
      "path": "/guide",
      "anchorText": "德州扑克新手规则"
    },
    {
      "keyword": "德州扑克入门教程",
      "path": "/guide",
      "anchorText": "德州扑克入门教程详解"
    },
    {
      "keyword": "德州扑克平台怎么选",
      "path": "/guide",
      "anchorText": "德州扑克平台怎么选教程"
    },
    {
      "keyword": "德州扑克平台下载",
      "path": "/download",
      "anchorText": "德州扑克平台下载"
    },
    {
      "keyword": "德扑平台安装教程",
      "path": "/install-guide",
      "anchorText": "德扑平台安装教程详解"
    },
    {
      "keyword": "德州扑克平台客服",
      "path": "/contact",
      "anchorText": "德州扑克平台客服处理流程"
    },
    {
      "keyword": "hhpoker官网",
      "path": "/",
      "anchorText": "hhpoker官网"
    },
    {
      "keyword": "hhpoker最新下载",
      "path": "/download",
      "anchorText": "hhpoker最新下载入口"
    }
  ],
  "faqEntries": [
    {
      "name": "德州扑克新手教程怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克规则怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克新手规则怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    },
    {
      "name": "德州扑克入门教程怎么处理？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "德州扑克核心流程：盲注→翻牌前→翻牌圈→转牌圈→河牌圈，每轮可选择弃牌/过牌/跟注/加注，最终比牌型大小决定胜负。"
      },
      "linkPath": "/guide"
    }
  ]
};

export default dailySeoContent;
